var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.handleClick}},[_vm._v("Test")]),_c('Pdfpreview',{attrs:{"file":_vm.file,"open":_vm.open}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }